import RoutesConfig from '@/constants/url';
import { useUser } from '@/contexts/AuthContext';
import { Button, Input } from 'antd';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

interface ICommentInput {
  onSubmit: (comment: string) => void;
}

const CommentInput = ({ onSubmit }: ICommentInput) => {
  const router = useRouter();
  const { user } = useUser();
  const [comment, setComment] = useState('');
  const { TextArea } = Input;

  const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(event.target.value);
  };

  const handleSubmit = () => {
    if (user) {
      setComment('');
      onSubmit(comment);
    } else {
      router.push(RoutesConfig.account.index);
    }
  };

  return (
    <div className="flex flex-col items-end gap-6 ">
      <TextArea
        className="w-full rounded py-3 px-4"
        value={comment}
        rows={5}
        onChange={handleInputChange}
        placeholder="Nhập bình luận..."
      />
      <Button
        disabled={comment?.trim()?.length === 0}
        className="bg-primary w-fit text-white px-4 py-1 font-bold rounded-lg "
        onClick={handleSubmit}
      >
        Gửi bình luận
      </Button>
    </div>
  );
};

export default CommentInput;
